import { withCsrfHeaders } from "./csrf";
// Get all details for a given no_inbois
export async function apiGetInboisDetailByNoInbois(no_inbois) {
  const response = await fetch(`/api/inbois_detail/by-no-inbois/${encodeURIComponent(no_inbois)}`);
  if (!response.ok) {
    throw new Error("Gagal memuatkan butiran inbois.");
  }
  return response.json();
}
// Bulk save (legacy)
export async function apiTambahInboisDetail(details) {
  const safeDetails = details.map((row) => ({
    ...row,
    kuantiti: row.kuantiti != null ? String(row.kuantiti) : "0",
    kadar: row.kadar != null ? String(row.kadar) : "0",
    jumlah: row.jumlah != null ? String(row.jumlah) : "0",
  }));
  const response = await fetch("/api/inbois_detail", {
    method: "POST",
    headers: await withCsrfHeaders({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify({ details: safeDetails }),
  });
  if (!response.ok) {
    throw new Error("Failed to save inbois_detail");
  }
  return response.json();
}

// Save single row
export async function apiTambahInboisDetailSingle(row) {
  const response = await fetch("/api/inbois_detail/single", {
    method: "POST",
    headers: await withCsrfHeaders({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(row),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || "Gagal menyimpan butiran.");
  }
  return response.json();
}

// Update single row
export async function apiUpdateInboisDetail(id, row) {
  const response = await fetch(`/api/inbois_detail/${id}`, {
    method: "PUT",
    headers: await withCsrfHeaders({
      "Content-Type": "application/json",
    }),
    body: JSON.stringify(row),
  });
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || "Gagal update butiran.");
  }
  return response.json();
}
